//import 'alpinejs';

import "./CurrencySwitcher.js";
import { initLanguageSwitcher } from "./LanguageSwitcher.js";
import { initElevationProfiles } from "./elevationProfile.js";
import { initGrandAngleModal } from "./GrandAngleModal.js";
import { initGpxDownloadModal } from "./GpxDownloadModal.js";
import { initGpxMapModal } from "./gpxMap.js";
import { initPointsMaps } from "./pointsMap.js";
import { initRefugeFilter } from "./RefugeFilter.js";

import {
  resolveLightboxSources,
  uncloakLinks,
  readableEmail,
  replaceOn,
  liveBlock,
  addClassForNormalUser,
} from "@pushword/js-helper/src/helpers.js";

import {
  ScrollYEnhancer,
  ScrollXEnhancer,
} from "@pushword/js-helper/src/ScrollEnhancer.js";

import { restoreUnpublishedLinks } from "@pushword/js-helper/src/unpublishedLinks.js";
import { initShowMore } from "@pushword/js-helper/src/ShowMore.js";
initShowMore();

function onPageLoaded() {
  initGrandAngleModal();
  initGpxDownloadModal();
  initGpxMapModal();
  onDomChanged();
  loadDesktopJs();
  new ScrollYEnhancer();
  //showProductBarOnScroll();
  //showNavbarOnScrool();
  new ScrollXEnhancer();
  initGalleryArrows();
  initProductToc();
  if (window.scrollX !== 0) window.scrollTo(0, window.scrollY); // ensure it's always align to left, fix a chrome bug when user come from Google with a `#:~:text=` link
}

function onDomChanged() {
  liveBlock();
  // Avant uncloakLinks() : consomme data-rot sur les .glightbox pour en faire le
  // data-href que lit la lightbox, et le <span> reste un <span> — l'URL du média
  // ne devient jamais un lien qu'un crawler suit. uncloakLinks() les laisse alors
  // tranquilles (elle ne cible que [data-rot]). Glightbox est instancié dans
  // desktop.js, chargé après : jamais avant cette passe. (rc834)
  resolveLightboxSources();
  uncloakLinks();
  addClassForNormalUser();
  readableEmail(".cea");
  replaceOn();
  initLanguageSwitcher();
  initElevationProfiles();
  initPointsMaps();
  initRefugeFilter();
  restoreUnpublishedLinks();
}

document.addEventListener("DOMContentLoaded", onPageLoaded());

document.addEventListener("DOMChanged", onDomChanged);

function loadDesktopJs() {
  if (window.innerWidth < 600) return;

  var jsToAdd = document.createElement("script");
  jsToAdd.type = "module";
  jsToAdd.src = window.desktopJsPath || "/assets/r/desktop.js";
  var head = document.getElementsByTagName("head")[0];
  head.appendChild(jsToAdd);
}

//window.addEventListener("resize", showNavbarSlider());
//window.addEventListener("load", showNavbarSlider());

function initProductToc() {
  const fold = document.querySelector(".pp-toc-fold");
  if (fold === null) return;

  // Le sommaire est replié dans le balisage : sous 1280 px la colonne revient
  // dans le flux juste après le chapô, et ses dix entrées y valent un écran
  // entier avant le premier paragraphe. Au-delà, il est dans la colonne de
  // droite où il ne pousse rien : on l'ouvre. L'inverse — ouvert en HTML,
  // refermé ici — ferait sauter la page au chargement, mobile compris.
  const wide = window.matchMedia("(min-width: 1280px)");
  const open = () => {
    if (wide.matches) fold.open = true;
  };
  open();
  wide.addEventListener("change", open);
}

function initGalleryArrows() {
  if (window.innerWidth < 1024) return;

  // Ce qui reste caché sous 2% de la largeur visible ne vaut pas une flèche : on
  // promet un déplacement, le clic ne montre rien de neuf. Le même seuil sert à
  // masquer la flèche en fin de course, sinon elle reparaît sur les derniers
  // pixels — celle qu'on venait d'éviter à l'ouverture.
  const slackOf = (ul) => Math.max(1, ul.clientWidth * 0.02);

  document.querySelectorAll("ul.gallery-scroll").forEach((ul) => {
    if (ul.scrollWidth - ul.clientWidth <= slackOf(ul)) return;

    let hoverCount = 0;
    const showArrows = () => {
      hoverCount++;
      leftBtn.style.opacity = "1";
      rightBtn.style.opacity = "1";
    };
    const hideArrows = () => {
      hoverCount--;
      requestAnimationFrame(() => {
        if (hoverCount <= 0) {
          leftBtn.style.opacity = "0";
          rightBtn.style.opacity = "0";
          hoverCount = 0;
        }
      });
    };

    const makeArrow = (dir) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gallery-arrow";
      btn.textContent = dir === "left" ? "‹" : "›";
      btn.addEventListener("click", () => {
        ul.scrollBy({
          left: dir === "left" ? -ul.clientWidth * 0.8 : ul.clientWidth * 0.8,
          behavior: "smooth",
        });
      });
      btn.addEventListener("mouseenter", showArrows);
      btn.addEventListener("mouseleave", hideArrows);
      document.body.appendChild(btn);
      return btn;
    };

    const leftBtn = makeArrow("left");
    const rightBtn = makeArrow("right");

    const update = () => {
      const rect = ul.getBoundingClientRect();
      const visLeft = Math.max(rect.left, 0);
      const visRight = Math.min(rect.right, window.innerWidth);
      const centerY = rect.top + rect.height / 2 - 20;

      leftBtn.style.top = centerY + "px";
      leftBtn.style.left = visLeft + 12 + "px";
      rightBtn.style.top = centerY + "px";
      rightBtn.style.left = visRight - 64 + "px";

      const slack = slackOf(ul);
      const canScrollLeft = ul.scrollLeft > slack;
      const canScrollRight =
        ul.scrollLeft + ul.clientWidth < ul.scrollWidth - slack;
      leftBtn.style.display = canScrollLeft ? "flex" : "none";
      rightBtn.style.display = canScrollRight ? "flex" : "none";
    };

    ul.addEventListener("scroll", update);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    ul.addEventListener("mouseenter", showArrows);
    ul.addEventListener("mouseleave", hideArrows);

    update();
  });
}
